var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownbtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 15,
    viewBox: "0 0 27 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4057 0.573599C26.025 0.206324 25.5088 0 24.9706 0C24.4323 0 23.9161 0.206324 23.5355 0.573599L13.4877 10.2711L3.44 0.573599C3.05717 0.216733 2.54443 0.0192657 2.01221 0.0237293C1.47999 0.028193 0.970875 0.234229 0.594525 0.597463C0.218175 0.960696 0.00469982 1.45206 7.49827e-05 1.96573C-0.00454986 2.4794 0.200047 2.97428 0.5698 3.34377L12.0526 14.4264C12.4333 14.7937 12.9495 15 13.4877 15C14.026 15 14.5422 14.7937 14.9228 14.4264L26.4057 3.34377C26.7862 2.97638 27 2.47817 27 1.95868C27 1.4392 26.7862 0.940985 26.4057 0.573599Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownbtn);
export default __webpack_public_path__ + "static/media/down btn.da0617155f380891795346fedc0bbaa4.svg";
export { ForwardRef as ReactComponent };